module.exports = __webpack_public_path__ + "img/myers.aa6d9abc.png";